export class KisFormState {
    public app_key = '';
    public app_secret = '';
    public account = '';
    public product_code = '01';
    public hts_id = '';
    public clear_hts_id = false;
    public kis_current_password = '';

    public reset(productCode: string = '01') {
        this.app_key = '';
        this.app_secret = '';
        this.account = '';
        this.product_code = productCode || '01';
        this.hts_id = '';
        this.clear_hts_id = false;
        this.kis_current_password = '';
    }

    public normalizeAccount() {
        this.account = String(this.account || '').replace(/\D/g, '').slice(0, 8);
    }

    public payload() {
        return {
            app_key: this.app_key,
            app_secret: this.app_secret,
            account: this.account,
            product_code: this.product_code,
            hts_id: this.hts_id,
            clear_hts_id: this.clear_hts_id,
            kis_current_password: this.kis_current_password
        };
    }

    public validation(hasSavedCredentials: boolean) {
        if (!hasSavedCredentials && !String(this.app_key || '').trim()) {
            return { field: 'app_key', message: 'App Key를 입력해주세요.' };
        }
        if (!hasSavedCredentials && !String(this.app_secret || '').trim()) {
            return { field: 'app_secret', message: 'App Secret을 입력해주세요.' };
        }
        const account = String(this.account || '').replace(/\D/g, '');
        if ((!hasSavedCredentials || account) && account.length !== 8) {
            return { field: 'account', message: '계좌번호 앞 8자리를 입력해주세요.' };
        }
        if (!String(this.kis_current_password || '')) {
            return { field: 'kis_current_password', message: '현재 비밀번호를 입력해주세요.' };
        }
        return null;
    }
}

export class StrategyFormState {
    public total_budget = 20000000;
    public live_budget = 0;
    public budget_mode = 'MANUAL';
    public daily_loss_limit_pct = 3;
    public order_ttl_seconds = 60;
    public live_approval = '';
    public strategy_current_password = '';

    private savedSnapshot = '';
    private savedLiveBudget = 0;
    private savedBudgetMode = 'MANUAL';

    public sync(value: any) {
        this.total_budget = Number(value?.total_budget ?? 20000000);
        this.live_budget = Number(value?.live_budget ?? 0);
        this.budget_mode = String(value?.budget_mode || 'MANUAL').toUpperCase();
        this.daily_loss_limit_pct = Number(value?.daily_loss_limit_pct ?? 3);
        this.order_ttl_seconds = Number(value?.order_ttl_seconds ?? 60);
        this.live_approval = '';
        this.strategy_current_password = '';
        this.savedSnapshot = this.snapshot();
        this.savedLiveBudget = this.live_budget;
        this.savedBudgetMode = this.budget_mode;
    }

    public get dirty() {
        return !!this.savedSnapshot && this.snapshot() !== this.savedSnapshot;
    }

    public get liveBudgetChanged() {
        return this.budget_mode !== this.savedBudgetMode || (
            this.budget_mode === 'MANUAL'
            && Number(this.live_budget || 0) !== this.savedLiveBudget
        );
    }

    public payload() {
        return {
            total_budget: this.total_budget,
            live_budget: this.live_budget,
            budget_mode: this.budget_mode,
            daily_loss_limit_pct: this.daily_loss_limit_pct,
            order_ttl_seconds: this.order_ttl_seconds,
            live_approval: this.live_approval,
            strategy_current_password: this.strategy_current_password
        };
    }

    public validation(needsLiveApproval: boolean = this.liveBudgetChanged) {
        const liveBudget = Number(this.live_budget || 0);
        if (!['AUTO', 'MANUAL'].includes(this.budget_mode)) {
            return { field: 'budget_mode', message: '운용 금액 방식을 확인해주세요.' };
        }
        if (this.budget_mode === 'MANUAL' && (liveBudget < 100000 || liveBudget > 1000000000)) {
            return { field: 'live_budget', message: '직접 한도는 10만원부터 10억원까지 입력해주세요.' };
        }
        if (needsLiveApproval && !String(this.strategy_current_password || '')) {
            return { field: 'strategy_current_password', message: '현재 비밀번호를 입력해주세요.' };
        }
        if (needsLiveApproval && this.live_approval !== '한놈 LIVE') {
            return { field: 'live_approval', message: '‘한놈 LIVE’를 정확히 입력해주세요.' };
        }
        return null;
    }

    private snapshot() {
        return JSON.stringify({
            total_budget: Number(this.total_budget || 0),
            live_budget: Number(this.live_budget || 0),
            budget_mode: this.budget_mode,
            daily_loss_limit_pct: Number(this.daily_loss_limit_pct || 0),
            order_ttl_seconds: Number(this.order_ttl_seconds || 0)
        });
    }
}
